import { render, staticRenderFns } from "./BookingEmpty.vue?vue&type=template&id=85787898"
import script from "./BookingEmpty.vue?vue&type=script&lang=js"
export * from "./BookingEmpty.vue?vue&type=script&lang=js"
import style0 from "./BookingEmpty.vue?vue&type=style&index=0&id=85787898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports